export function isOneOf<T>(variable: T, ...options: T[]): boolean {
  return options.indexOf(variable) !== -1;
}
